import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Funcionario } from '../classes/Funcionario';

@Injectable({
  providedIn: 'root'
})
export class FuncionarioService {

  constructor(private http: HttpClient) { }

  listarAtivos(): Observable<any>{
    return this.http.get(`${environment.apiURL}/funcionario`)
  }

  listarTodos(): Observable<any>{
    return this.http.get(`${environment.apiURL}/funcionario/ListarTodos`)
  }

  getFuncionario(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/funcionario/${id}`)
  }

  postFuncionario(funcionario: Funcionario): Observable<any>{
    return this.http.post(`${environment.apiURL}/funcionario`, funcionario);
  }

  putFuncionario(id: number, funcionario: Funcionario): Observable<any>{
    return this.http.put(`${environment.apiURL}/funcionario/${id}`, funcionario);
  }

  deleteFuncionario(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/funcionario/${id}`);
  }
  inativar(ids: number[]): Observable<any>{
    return this.http.put(`${environment.apiURL}/funcionario/inativar`, ids);
  }
  duplicar(ids: number[]): Observable<any>{
    return this.http.post(`${environment.apiURL}/funcionario/duplicar`, ids);
  }
  deleteFuncionarios(ids: number[]): Observable<any>{
    const params = ids.map(id => `ids=${id}`).join('&');
    return this.http.delete(`${environment.apiURL}/funcionario?${params}`, );
  }
}
